import React, { useState } from 'react';
import { Container, Column, Title, Subtitle, Logo, ContentProfile, User, Photo, Name, Country, LogoForgotPage } from './styles';
//import logo from './fitinsur-logo-white.svg';
//import logo from './excelsior-logo-01.jpg';
//import logo from './zurich-logo-04.jpg';
import logo from '../Menu/LogoFitInsurBranco1.png';
import { Link } from 'react-router-dom';
import { TextStyled } from 'flows/base/pages/login/styles';
import { Profile, Icon } from 'components';

//const defaultSubTitleText = "Você está criando uma nova cotação.";



export default function Header(props) {

  const user = props.user || false;

  const [showProfile, setShowProfile] = useState(false);

  return (
    <Container>

      <Column>
        <Title>{(props.title ? props.title : "Nova Cotação")}</Title>
        {props.subtitleClickHandler &&
          <Subtitle onClick={props.subtitleClickHandler}>
            {props.subtitle ? props.subtitle : ''}
          </Subtitle>
        }
        {!props.subtitleClickHandler &&
          <Subtitle>
            {props.subtitle ? props.subtitle : ''}
          </Subtitle>
        }
        {(props.linkAnchor && props.linkText) && <Link to={props.linkAnchor} style={{ textDecoration: 'none', color: '#6CBACA' }}>
          {props.linkText}
          </Link>
        }
      </Column>

      {user ?
        <Column>
          <User onClick={() => setShowProfile(!showProfile)}>
            <Photo>
              <Icon name="user" />
              <Icon name="check-ok" />
            </Photo>
            <Name>{user.name}</Name>
            <Country>{user.country}</Country>
          </User>
          <ContentProfile className={showProfile ? 'profile-open' : ''}>
            <Icon name="close" className="icon-close" onClick={() => setShowProfile(false)} />
            <Profile user={user} />
          </ContentProfile>
        </Column>

        : <Column>
          <Logo src={logo}></Logo>
        </Column>
      }
     

    </Container>
  );
}
